<script setup>
import InputTypeFile from "@/utilities/InputTypeFile.vue";
import {ref, computed} from "vue";
import * as toastr from "toastr";
import store from "@/store";
import Spinner from "@/components/Controls/Spinner.vue";

const file = ref(null);
const preview = ref(null);
const toImport = ref([]);
const completed = ref([]);
const errors = ref([]);

const accountId = computed(() => store.getters.currentAccountOverview.id);

async function change(event) {
    console.log('change')
    file.value = event.target.files[0];
    preview.value = await file.value.text();
}

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

const doNext = async () => {
    const next = toImport.value.shift();
    if (!next) return;

    try {
        await window.$app.api.post(`/accounts/${accountId.value}/topics.csv`, next, {headers: {"Content-Type": "text/csv"}});
        completed.value.push(next);
    } catch (error) {
        errors.value.push(next);
    }
    await sleep(1000);
    await doNext();
}

const start = () => {
    console.log('* ImportBulkTopicsCsv.vue preview.value', preview.value)
    if (!preview.value) {
        toastr.error("No CSV data to import.");
        return;
    }

    toImport.value = preview.value
        .split('\n')
        .map(line => line.trim())
        .filter(line => !line.toLowerCase().startsWith("name,"))
        .filter(line => line.length > 0);

    completed.value = [];
    errors.value = [];
    doNext()
}
const name = (item) => item && item.split(',')[0]
</script>

<template>
    <form>
        <InputTypeFile accept="text/csv" name="importFile" file-type-label="File" @changed="change"/>
        <div v-if="file">
            <div>
                <button
                    class="btn btn-primary full-width mb-4"
                    type="button"
                    @click="start"
                    :disabled="toImport.length"
                >Start bulk topic import</button>
                <div class="row" style="">
                    <div class="col col-4 scroll-container">
                        <strong>To Do</strong>
                        <div class="overflow-y-scroll scroll-container">
                            <div v-for="(item, index) in toImport" :key="item" :class="{'fw-bold': index === 0, 'text-muted': index !== 0}">
                                <i class="fa fa-regular fa-circle" />
                                {{name(item)}}
                                <Spinner v-if="index === 0" class="d-inline"/>
                            </div>
                        </div>
                    </div>
                    <div class="col col-4">
                        <strong>Done</strong>
                        <div class="overflow-y-scroll scroll-container">
                            <div v-for="item in completed" :key="item" class="text-success">
                                <i class="fa fas fa-check-circle" /> {{name(item)}}
                            </div>
                        </div>
                    </div>
                    <div class="col col-4 scroll-container">
                        <strong>Errors</strong>
                        <div class="overflow-y-scroll scroll-container">
                            <div v-for="item in errors" :key="item" class="text-danger">
                                <i class="fa fas fa-exclamation-circle text-danger" /> {{item}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<style scoped>
    .scroll-container {
        max-height: calc(100vh - 300px);
    }
</style>
